import React, { useState, useEffect, useRef  } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { useParams,NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Preloader from "../../../components/Preloader/Preloader";
import LoadingOverlay from 'react-loading-overlay';
import ReactPDF from '@react-pdf/renderer';
import {PDFDownloadLink} from '@react-pdf/renderer';
import {PdfDocument} from "../../../components/PDF/PackageSalesSummaryPdf";
import {PdfDocumentFS} from "../../../components/PDF/PackageSalesSummaryPdfFS";
import ReactToPrint from "react-to-print";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import notreleaseimg from "../../../assets/img/empty-cart.gif";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	cardStyleHeight:{
		height:"100%"
	},
	floatright:{
		float:"right"
	},    
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "400px",
		margin: "0 auto",
	},
	modal_itr: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	paddingmarginzero :{
		padding:"0 !important",
		margin:"0 !important",
		fontWeight:"bold"
	},
	margintop:{
		marginTop:"10px"
	},
	printButton:{
		"& a":{color:"#fff !important"}
	}
}));

const PackageSalesView = (props) => {
	const classes = useStyles();
	const {idno} = useParams();
	const eligibleforrelease = "yes";
    const isfs = "";
	//ApiData Component useState SOF
	const [nextPagePath, setnextPagePath] = useState("");
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
	const [isLoaded, setisLoaded] = useState(false);
	const [headerDetailsP, setHeaderDetailsP] = useState([]);
	const [itemDetailsP, setItemDetailsP] = useState([]);
	const [computationDetailsP, setComputationDetailsP] = useState([]);
	const [paymentP, setPaymentP] = useState([]);
	const [showPrint, setHidePrint] = useState(false);
	const history = useHistory();
	//Core datas
	const [memberpaymentsDetails, setmemberpaymentsDetails] = useState({});
	const [paymentDetails, setpaymentDetails] = useState({});
	const [itemDetails, setitemDetails] = useState({});
	const [ITRDetails, setITRDetails] = useState({});
	const [computationDetails, setcomputationDetails] = useState({});
	const [transactionDetails, setTransactionDetails] = useState({});
	const toprint = useRef(null)
	const headers = {
        'Content-Type': 'multipart/form-data',
    };
	const get_packagesales_details = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
			idno: idno,
			jc_curcode: branchCurcode
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packagesalessummarydetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setmemberpaymentsDetails(res.data.memberpaymentsDetails);
			setpaymentDetails(res.data.paymentDetails);
			setitemDetails(res.data.itemDetails);
			setcomputationDetails(res.data.computations);
		});
	};
	const get_itr_details = async () => {
        await axios.get(
			process.env.REACT_APP_API_URL+'getitrdetails', {
            params:{
                idno: idno
            }
        }).then((res)=>{
			if(res.data.result.success == 1){
				// setITRDetails(res.data.result.ITRDetails);
			}
		}).catch((error)=>{
			// console.log(error.message);
		})
    }

	const get_packagesales_details_fs = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			idno: idno
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packagesalessummarydetailsfs';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setTransactionDetails(res.data.transactioninfo);
			setHidePrint(true);
		});
	};

	const get_packagedetailspdf = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
			idno: idno,
			curcode: branchCurcode
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'getpackagedetailspdf';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setHeaderDetailsP(res.data.header_details);
			setItemDetailsP(res.data.item_details);
			setPaymentP(res.data.paymentDetails);
			setComputationDetailsP(res.data.computations_details);
			setHidePrint(true);
		});
	};

	const releasepackage = (idno) => {
        setShowOverlay(true);
        setOverlayMsg('Processing Release...');
		//get data for warehouse/location dropdown
		const form_data = {
            hqidno: branchIdNo,
			idno: idno
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'releasepackage';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("success");
				setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
					setShowMsgBox(false);
					window.location.reload(false);
				}, 3000)
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Loading overlay
	const [showOverlay, setShowOverlay] = useState(false);
	const [overLayMsg, setOverlayMsg] = useState(false);
	//Loading overlay EOF

	//Table Settings
	const [TABLE_DATA_PAYMENT, loadPaymentTable] = useState([]);
	const [TABLE_DATA_ITEMS, loadItemTable] = useState([]);
	const [TABLE_DATA_ITR, loadItemToRelease] = useState([]);

	const prep_table_payment = () => {
		const newData = [...TABLE_DATA_PAYMENT];
		for (let i=0;i < paymentDetails.length;i++) {
			const tempObj = {paymenttype:paymentDetails[i].paymentid, refno:paymentDetails[i].refno, amount:paymentDetails[i].amount}
			newData.push(tempObj);	
		}
		loadPaymentTable([...newData]);
	};

	const prep_table_item = () => {
		const newData = [...TABLE_DATA_ITEMS];
		for (let i=0;i < itemDetails.length;i++) {
			const tempObj = {count:itemDetails[i].counting, itemname:itemDetails[i].itemname, itemqty:Math.abs(itemDetails[i].qty), unit:itemDetails[i].unit, itemprice:itemDetails[i].itemprice, totalamt:itemDetails[i].totalamount}
			newData.push(tempObj);	
		}
		loadItemTable([...newData]);
	};

	const prep_table_itr = () => {
		const newData = [...TABLE_DATA_ITR];
		for (let i=0;i < ITRDetails.length;i++) {
			const tempObj = {itemname:ITRDetails[i].itemname, itemqty:Math.abs(ITRDetails[i].qty), unit:ITRDetails[i].unit}
			newData.push(tempObj);	
		}
		loadItemToRelease([...newData]);
	};

	const refreshTables = (params) => {
		if(params == "payment"){
			TABLE_DATA_PAYMENT.length = 0;
        	const newData = [...TABLE_DATA_PAYMENT];
			loadPaymentTable([...newData]);
		}else if(params == "itr"){
			TABLE_DATA_ITR.length = 0;
			const newData = [...TABLE_DATA_ITR];
			loadItemToRelease([...newData]);
		}else{
			TABLE_DATA_ITEMS.length = 0;
			const newData = [...TABLE_DATA_ITEMS];
			loadItemTable([...newData]);
		}
	}

	const TABLE_COLUMNS_PAYMENT = [
		{
		  name: 'paymenttype',
		  label: 'Type',
		}, {
		  name: 'refno',
		  label: 'Reference',
		}, {
			name: 'amount',
			label: 'Amount',
		  }
	];

	const TABLE_COLUMNS_ITEMS = [
		{
		  name: 'count',
		  label: 'No.',
		}, {
		  name: 'itemname',
		  label: 'Item Name',
		}, {
		  name: 'itemqty',
		  label: 'Qty',
		}, {
			name: 'unit',
			label: 'Unit',
		}, {
			name: 'itemprice',
			label: 'Price',
		}, {
			name: 'totalamt',
			label: 'Total',
		}
	];

	const TABLE_COLUMNS_ITR = [
		{
			name: "count",
			label: "#",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (rowIndex, dataIndex) => dataIndex.rowIndex + 1 
			}
		},{
		  name: 'itemname',
		  label: 'Item Name',
		}, {
		  name: 'itemqty',
		  label: 'Qty',
		}, {
			name: 'unit',
			label: 'Unit',
		}
	];
	
	const TABLE_OPTION_PAYMENT = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false

	};

	const TABLE_OPTION_ITEMS = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false
	};

	const TABLE_OPTION_ITR = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	//Modal Settings EOF

	//Modal Settings Table of Items
	const [open2, setOpen2] = useState(false);
	const handleOpen2 = () => {
		setOpen2(true);
	};

	const handleClose2 = () => {
		setOpen2(false);
	};
	//Modal Settings Table of Items EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
		isLoggedIn();
		if(isfs == ""){
			get_packagesales_details();
			get_packagedetailspdf();
			get_itr_details();
		}else{
			get_packagesales_details_fs();
		}
    }, []);
	useEffect(() => {
		refreshTables("payment");
		prep_table_payment();
    }, [paymentDetails]);
	useEffect(() => {
		refreshTables("items");
		prep_table_item();
    }, [itemDetails]);
	useEffect(() => {
		refreshTables("itr");
		prep_table_itr();
    }, [ITRDetails]);
    //OnLoad Event/Data Fetching SOF

    //Api Functions SOF
        // Code blocks here
	//Api Request Functions EOF

	//FormData
	const [prep_data, setData] = useState({});
	//FormData EOF
	// const nextpage =  {
	// 	// pathname: "/package-sales-payment",
	// 	pathname: nextPagePath,
	// 	transactionInfo: TransactionInformation, // your data array of objects
	// 	selectedpackagesInfo:TABLE_DATA,
	// 	pageInfo: {
	// 		navid: navid,
	// 		navname: CurrentPage
	// 	}
	// }
	const confirmrelease = () => {
        handleOpen();
    }
	const viewITR = () => {
        handleOpen2();
    }
	return (
		!idno ? <Redirect to={"/package-sales-summary"+
		"/" + 0} /> :
		<div className="page">
			<LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header noprint">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/package-sales">
						<h2 className="header-title">Package Sales</h2>
					</NavLink>
					<NavLink to={"/package-sales-summary"+ "/" + 0}>
						<h2 className="header-title">Package Sales Summary</h2>
					</NavLink>
					<Typography color="textPrimary">Package Sales Summary Details</Typography>
				</Breadcrumbs>

				<Button onClick={() => history.goBack()}>Go Back</Button>
			</div>
			<div className="page-container"> 
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				    <Grid container spacing={2} alignItems="stretch" justify="center" className={classes.root}>
					{isfs == "" ? 
						<Grid item xs={6}>
                            <Card>
                                <CardContent>
									<div className={classes.cardStyleHeight}>
										<Grid container spacing={1}>
											<Grid xs={12} sm={6}>
												<h4 className={classes.title}>Transaction Information</h4>
											</Grid>
										</Grid>
										<Grid container>
											<Grid item xs={12}>
												<Grid container>
													<Grid xs={12} sm={12}>
														<h2 className={classes.paddingmarginzero}>{memberpaymentsDetails.soldto}</h2>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Date:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.date}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Reference No.:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.refno}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>ID No.:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.idno}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Account Type:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.accounttype}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Location:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.location}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Amount:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.amount}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Package:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.package}</FormLabel>
													</Grid>
												</Grid>
											</Grid>
										</Grid>								
									</div>
                                </CardContent>
                            </Card>
                        </Grid>
						: null}
						{!isfs == "" ? 
							<Grid item xs={12}>
								<Card>
									<CardContent>
										<div className={classes.cardStyleHeight}>
											<Grid container spacing={1}>
												<Grid xs={12} sm={6}>
													<h4 className={classes.title}>Transaction Information</h4>
												</Grid>
												<Grid xs={12} sm={6} >
													<div className={[classes.floatright]}>
														<Grid xs={12} className={classes.paddingmarginzerostyle}>
															<FormLabel className={classes.paddingmarginzerostyle}>{transactionDetails.refno}</FormLabel>
														</Grid>
														<Grid xs={12} className={classes.paddingmarginzerostyle}>
															<FormLabel className={classes.paddingmarginzerostyle}>{transactionDetails.date}</FormLabel>
														</Grid>
													</div>
												</Grid>
											</Grid>
											<Grid container spacing={1}>
												<Grid item xs={12}>
													<Grid container>
														<Grid xs={12} sm={3}>
															<h2 className={classes.title}>{transactionDetails.soldto}</h2>
														</Grid>
													</Grid>
													<Grid container>
														<Grid xs={12} sm={3}>
															<FormLabel>ID No.: {transactionDetails.idno}</FormLabel>
														</Grid>
													</Grid>
													<Grid container>
														<Grid xs={12} sm={3}>
															<FormLabel>Pin No: {transactionDetails.pinno}</FormLabel>
														</Grid>
													</Grid>
													<Grid container>
														<Grid xs={12} sm={3}>
															<FormLabel>Activation No. {transactionDetails.actno}</FormLabel>
														</Grid>
													</Grid>
												</Grid>
											</Grid>								
										</div>
									</CardContent>
								</Card>
							</Grid>						
						: null}
						{isfs == "" ? 
						<Grid item xs={6}>
							<Grid container>
								<Grid item xs={12}>
									<MUIDataTable
										title={
											<div>
												<div className="table-title">
													Payment Details
												</div>
											</div>
										}
										id="table-grid-payment"
										data={TABLE_DATA_PAYMENT}
										columns={TABLE_COLUMNS_PAYMENT}
										options={TABLE_OPTION_PAYMENT}
									/>
								</Grid>
							</Grid>
                        </Grid>
						: null}
						
						<Grid item xs={12} className="noprint">
							<Grid container spacing={2}>
								<Grid item xs={12}>
										<MUIDataTable
										title={
											<div>
												<div className="table-title">
													Item Details
												</div>
											</div>
										}
										id="table-grid"
										data={TABLE_DATA_ITEMS}
										columns={TABLE_COLUMNS_ITEMS}
										options={TABLE_OPTION_ITEMS}
										/>								
								</Grid>
							</Grid>
                        </Grid>
						{!isfs == "" ?
							<Grid item xs={12} className="yesprint"> 
								<Card>
									<CardContent>
									{eligibleforrelease =="yes" ? 
										<img src={notreleaseimg} />
									: 
										<Grid container spacing={2}>
										<Grid item xs={2}>No.</Grid>
										<Grid item xs={2}>Item Name</Grid>
										<Grid item xs={2}>Qty</Grid>
										<Grid item xs={2}>Unit</Grid>
										<Grid item xs={2}>Price</Grid>
										<Grid item xs={2}>Total</Grid>
										</Grid>
									}
									</CardContent>
								</Card>
							</Grid>
						: null}
						{isfs == "" ? 
						<Grid container justifyContent={"space-between"}>
						<Grid item xs={6}>
						<Grid container className={[classes.margintop,"noprint"]}>
						
						<Grid item xs="12" sm="3">

							{isfs == "" ? 
							<div className={classes.printButton}>
								{showPrint && <Button 
						
								variant="contained" 
								color="success"
								style={{
									color: "#FFF !important",
									backgroundColor: "green",marginLeft:"10px",width:"200px"}}><PDFDownloadLink  
									document={<PdfDocument className="MuiButton-root" headers={headerDetailsP} items={itemDetailsP} computations={computationDetailsP} payment={paymentP} />}
									fileName={"PACKAGESALES_"+idno+".pdf"}
		
									// style={{
									// 	textDecoration: "none",
									// 	color: "white",
									// 	backgroundColor: "green",
									// 	border: "1px solid #4a4a4a",
									// 	padding: "6px 16px",
									// 	textTransform:"uppercase",
									// 	borderRadius:"4px",
									// 	fontSize:"0.875rem",
									// 	minWidth:"64px",
									// 	height:"36px !important",
									// 	fontWeight:"500",
									// 	letterSpacing:"0.02857em"
									// }}
								>
									{({ blob, url, loading, error }) =>
									loading ? "Loading document..." : "Print Package Sales"
									}
								</PDFDownloadLink></Button>}
							</div>
							: 
							<Button onClick={(e) => {window.print();}} variant="contained" 
						 style={{
								color: "#FFF!important",
								backgroundColor: "green"}}>Print Package Sales</Button>
							}
						</Grid>
				</Grid>
						</Grid>
						<Grid item xs={6}>
						<Grid container>
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Total Amount: {computationDetails.total_amount_display}</h4>
								</Grid>
								{!computationDetails.shipping_fee_display == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Shipping/Freight: {computationDetails.shipping_fee_display}</h4>
								</Grid>
								: null}
								{!computationDetails.discount == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Discount: {computationDetails.discount}</h4>
								</Grid>
								: null}
								{!computationDetails.netamountnovat == "" ?
								<Grid  item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Net Amount: {computationDetails.netamountnovat}</h4>
								</Grid>
								: null}
								{!computationDetails.vatamount == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>VAT Amount: {computationDetails.vatamount}</h4>
								</Grid>
								: null}
								{!computationDetails.grand_total_amount_display == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Grand Total: {computationDetails.grand_total_amount_display}</h4>
								</Grid>
								: null}
							</Grid>
						</Grid>
						</Grid>

						: null}
                    </Grid>

					<div>

					</div>
					{/* Item Details TABLE Modal */}

                </form>
			</div>
			</LoadingOverlay>
		</div>
	);
};

export default PackageSalesView;
